import { useAuth } from '@/shared/auth';
import { useProfileWithTikTok } from './useProfile';

/**
 * 현재 로그인된 사용자의 프로필 정보를 조회하는 훅
 * TikTok 정보가 포함된 전체 프로필을 반환합니다.
 */
export function useMyProfile() {
  const user = useAuth(s => s.user);
  const isAuthLoading = useAuth(s => s.isLoading);

  const { data: profile, isLoading: isProfileLoading, refetch } = useProfileWithTikTok(user?.id);

  return {
    profile: profile ?? null,
    isLoading: isAuthLoading || isProfileLoading,
    refetch,
  };
}
